module.exports = __webpack_public_path__ + "static/media/place_wall.79d93d0a.png";